import {h} from 'preact'
import Popup from "./Popup";
import {useContext, useRef, useState} from "preact/hooks";
import {useDidUpdate} from "../../utils/hooks/useDidUpdate";
import {BookingContext} from "../../context/BookingContextProvider";

export default ({onVerify, onResend, open, onClose, onBack, verified}) => {

    const context = useContext(BookingContext)

    const [val1, setVal1] = useState('')
    const [val2, setVal2] = useState('')
    const [val3, setVal3] = useState('')
    const [val4, setVal4] = useState('')
    const ref1 = useRef(null);
    const ref2 = useRef(null);
    const ref3 = useRef(null);
    const ref4 = useRef(null);




    const updateValues = (index, e) => {

        if (!e) {
            switch (index) {
                case 1 :
                    setVal1(e);
                    ref1.current.value = e;
                    break;
                case 2 :
                    setVal2(e);
                    ref2.current.value = e;
                    document.getElementById('verification-1-input').focus();
                    break;
                case 3 :
                    setVal3(e);
                    ref3.current.value = e;
                    document.getElementById('verification-2-input').focus();
                    break;
                case 4 :
                    setVal4(e);
                    ref4.current.value = e;
                    document.getElementById('verification-3-input').focus();
                    break;
            }

        } else {
            const val = e.replace(/\D/g, '').slice(-1)
            switch (index) {
                case 1 :
                    setVal1(val);
                    ref1.current.value = val;
                    document.getElementById('verification-2-input').focus();
                    break;
                case 2 :
                    setVal2(val);
                    ref2.current.value = val;
                    document.getElementById('verification-3-input').focus();
                    break;
                case 3 :
                    setVal3(val);
                    ref3.current.value = val;
                    document.getElementById('verification-4-input').focus();
                    break;
                case 4 :
                    setVal4(val);
                    ref4.current.value = val;
                    break;
            }
        }

    }
    const verify = () => {
        onVerify(`${val1}${val2}${val3}${val4}`);
    }

    const resend = () => {
        context.setTimeRemain(60)
        context.setResetInterval(true)
        onResend()
    }

    const paste = (e) => {
        let val = (e.clipboardData || window.clipboardData).getData('text') || e.target.value
        val = val.replace(/\D/g, '')
        updateValues(1, val[0] || '')
        updateValues(2, val[1] || '')
        updateValues(3, val[2] || '')
        updateValues(4, val[3] || '')


    }

    useDidUpdate(() => {
        if (open) {
            document.getElementById('verification-1-input').focus()
        }
    }, [open])

    return (
        <Popup onClose={onClose} open={open} id="verification-popup" className="choose-popup">
            <div className="menu-header">
                <div className="title">
                    <button onClick={() => {
                        onBack();
                    }} className="btn-back"><img src="/assets/images/icon-back.svg" alt="Back to previous step"/>
                    </button>
                    <h3>Phone Verification</h3>
                </div>
                <button onClick={onClose} className="btn-close"><img src="/assets/images/icon-close.svg"
                                                                     alt="Close menu"/></button>
            </div>
            <div className="verification-form">
                <div className="verification-card">
                    <div className="card-holder">
                        <strong className="logo-mirron">Mirron</strong>
                        <p>Please enter the verification code.<br/>{context.resetInterval &&
                            <span>Resend code in {context.timeRemain} sec</span>}</p>
                        <div className="numbers-row error">
                            <div className="col">
                                <input onPaste={paste} type={'tel'} id={'verification-1-input'} ref={ref1}
                                       onInput={(e) => updateValues(1, e.target.value)} value={val1}/>
                            </div>
                            <div className="col">
                                <input onPaste={paste} type={'tel'} id={'verification-2-input'} ref={ref2}
                                       onInput={(e) => updateValues(2, e.target.value)} value={val2}/>
                            </div>
                            <div className="col">
                                <input onPaste={paste} type={'tel'} id={'verification-3-input'} ref={ref3}
                                       onInput={(e) => updateValues(3, e.target.value)} value={val3}/>
                            </div>
                            <div className="col">
                                <input onPaste={paste} type={'tel'} id={'verification-4-input'} ref={ref4}
                                       onInput={(e) => updateValues(4, e.target.value)} value={val4}/>
                            </div>
                            {!verified && <p className="error-message">Invalid verification code, please try again.</p>}
                        </div>
                        {!context.resetInterval &&
                            <p className="note link"><a onClick={resend} className="new-code-popup-opener">Resend code
                                via SMS</a></p>}

                    </div>
                </div>
                <button onClick={verify} className="btn booking-details-popup-opener">
                    <img src="/assets/images/icon-star.svg" alt=""/>
                    <span>Continue</span>
                </button>
            </div>
        </Popup>
    )
}